module.exports = __webpack_public_path__ + "media/images/dashboard_icons/ic_transactions-85263ed7cfa5e60439221c151a047742.svg";